import Cookies from 'js-cookie';
import { createCartV2 } from '../../services/LineTableService';
import {
  BASE,
  BASE_PRICE,
  CONTRACT,
  DEFAULT_MOBILEPOSTPAID_BUNDLE,
  HARDWARE,
  INSTALLMENTS,
  ONE_ECOMMERCE_HARDWARE_SUMMARY,
  SMARTUPGRADEINSTALLMENTS
} from '../../utils/constants';
import { checkLinkWithLang } from '../../utils/utils';

export interface hardwareSessionSchema {
  id: string;
  note: any;
  hardwarePrices: any;
  selectedContractType: string;
  deviceRedirectUrl: string;
  buyBackPrice: any;
  itemType: string;
  insuranceName?: string;
  insurancePrice?: string;
}

export interface hardwareSessionObj {
  hardwareVariant: hardwareSessionSchema;
}

export interface checkSubscriptionsSchema {
  mbbSupportedSubscription: boolean;
  simSelectedType: string;
  enableV2Layout: boolean;
  enableNoSubscriptionFlow: boolean;
  dpSubsidyRatePlanPromoId: string;
  enableRecommendedAccessory: boolean;
}
export interface hardwareSessionObjV2 {
  hardwareVariant: hardwareSessionSchema;
  checkSubscriptions: checkSubscriptionsSchema;
}

export const getDeviceWithVarients = (deviceData: any) => {
  const deviceVarientsList: any = [];
  const colorsArray: any[] = [],
    storageArray: any[] = [];
  let defaultColorSelected, defaultMemorySelected;
  if (deviceData) {
    (deviceData?.hardwares || [])?.forEach((devices: any) => {
      const hasSmartUpgrade = devices?.hardwarePrices?.find(
        (data: any) => data?.priceCategory === CONTRACT && data?.residual
      );
      if (hasSmartUpgrade) {
        let color = '',
          storage = '';
        // Handle new variant structure
        if (devices?.variant) {
          color = devices?.variant?.color || '';
          storage = devices?.variant?.storage || '';
          if (color) colorsArray.push(color);
          if (storage) storageArray.push(storage);
        }
        if (devices?.isDefaultVariantProduct) {
          defaultColorSelected = color;
          defaultMemorySelected = storage;
        }
        deviceVarientsList[`${color}-${storage}`] = {
          ...devices,
          hardwarePrices: alterHardwarePriceFormatDeviceDetail(devices?.hardwarePrices)
        };
      }
    });
  }
  if (deviceVarientsList && Object?.keys(deviceVarientsList)?.length > 0) {
    return {
      deviceVarientsList: deviceVarientsList,
      colorsList: [...new Set(colorsArray)],
      memoryList: [...new Set(storageArray)],
      defaultColorSelected: defaultColorSelected,
      defaultMemorySelected: defaultMemorySelected
    };
  } else {
    return false;
  }
};

export const getOptionsList = (options: string[]) => {
  const optionsList: any[] = [];
  (options || [])?.forEach((value: string) => {
    optionsList.push({
      id: value,
      name: value
    });
  });
  return optionsList;
};

export const dpTableCreateCart = (
  setShowLoader: any,
  mainContent: any,
  mobileData: any,
  deviceData: any,
  cartEndPoint: any,
  redirectionUrl: any
) => {
  try {
    setShowLoader(true);
    const newDeviceData = { ...deviceData, insuranceName: mainContent?.insuranceId ?? '' };
    mobileData?.mobProductId &&
      deviceData &&
      createCartV2(
        mobileData?.mobProductId,
        '',
        mobileData?.mobPromoId ? mobileData?.mobPromoId : DEFAULT_MOBILEPOSTPAID_BUNDLE,
        cartEndPoint,
        'mobile',
        '',
        '',
        '',
        false,
        '',
        newDeviceData
      )
        .then((res: any) => {
          Cookies.remove('one-commerce-cartId', { path: '/' });
          // saving newly created cartid in the cookies.
          Cookies.set('one-commerce-cartId', res?.id, { path: '/' });
          Cookies.set('cartProduct', mobileData?.mobProductId, { path: '/' });
          window.location.href = redirectionUrl;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
          setShowLoader(false);
        })
        .finally(() => {
          setShowLoader(false);
        });
  } catch (error) {}
};

export const setDeviceSessionObject = (
  mainContent: any,
  productData: any,
  offerDataList: any,
  deviceDetails: any,
  priceValues: any,
  redirectionUrl: any
) => {
  const insuranceValue =
    deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments?.insurance
      ?.value ?? 0;
  const upFrontValue =
    deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments?.upFrontPayment
      ?.value ?? '';
  let currentUrl = '';
  if (typeof window !== 'undefined') {
    const url = window.location.href;
    const lang = window.document.documentElement.getAttribute('lang');
    const position = url?.search(`/${lang}`);
    currentUrl = url?.slice(position);
  }
  const sessionObj: any = {
    hardwareVariant: {
      id: deviceDetails?.selectedVarientDetails?.id,
      note: getDeviceNotes(deviceDetails, upFrontValue),
      hardwarePrices: deviceDetails?.selectedVarientDetails?.hardwarePrices,
      selectedContractType: CONTRACT,
      deviceRedirectUrl: '',
      buyBackPrice: [],
      itemType: HARDWARE,
      insuranceName: insuranceValue ? mainContent?.insuranceId ?? '' : '', //flex name to be replaced with the actul name from res
      insurancePrice: insuranceValue ? insuranceValue : ''
    },
    checkSubscriptions: {
      simSelectedType: '',
      enableV2Layout: true,
      enableNoSubscriptionFlow: true,
      dpSubsidyRatePlanPromoId: '',
      flowType: 'dpTable',
      enableRecommendedAccessory: deviceDetails?.selectedVarientDetails?.classification?.recommendAccessory ?? false,
    },
    subscription: {
      mobileSubscription: productData?.mobProductId,
      mobileSubscriptionPromo: offerDataList?.[productData?.mobProductId]?.promotionInfo?.[0]?.id
        ? offerDataList?.[productData?.mobProductId]?.promotionInfo?.[0]?.id
        : DEFAULT_MOBILEPOSTPAID_BUNDLE,
      originalPrice: priceValues?.totalBasePrice ?? 0,
      discountedPrice: priceValues?.totalDiscountedPrice ?? 0,
      ubRedirectUrl: checkLinkWithLang(currentUrl)
    }
  };
  sessionObj && sessionStorage.setItem(ONE_ECOMMERCE_HARDWARE_SUMMARY, JSON.stringify(sessionObj));
  window.location.href = redirectionUrl;
};

export const getDeviceNotes = (deviceDetails: any, upFrontValue: string) => {
  // market price display
  const isMarketPrice = deviceDetails?.selectedVarientDetails?.hardwarePrices?.MARKET;

  const smartUpgradePrice =
  Number(deviceDetails?.selectedVarientDetails?.hardwarePrices?.installments?.monthlyInstallment?.value) -
  Number(
    deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments?.monthlyInstallment?.value
  );

  const notes = [
    {
      author: 'flowInitiated',
      text: HARDWARE
    },
    {
      author: 'hardwareConfiguration',
      text: `${deviceDetails?.selectedColor}, ${deviceDetails?.selectedStorage}`
    },
    {
      author: 'hardwareImageUrl',
      text: deviceDetails?.selectedImageUrl ?? ''
    },
    {
      author: 'hardwareGroupName',
      text: deviceDetails?.selectedDeviceModal
    },
    {
      author: 'hardwareCategory',
      text: 'smartphone'
    },
    {
      author: 'upfront',
      text: upFrontValue
    },
    {
      author: 'ultimateBundle',
      text: 'true'
    },
    {
      author: 'RESIDUAL',
      text: 'true'
    }
  ];

  if (isMarketPrice?.monthlyFlashDiscount) {
    notes?.push({
      author: 'monthlyFlashDiscount',
      text: isMarketPrice?.monthlyFlashDiscount?.value,
    });
  }
  if (isMarketPrice?.monthlyFlashDiscount) {
    notes?.push({
      author: 'totalFlashDiscount',
      text: isMarketPrice?.totalFlashDiscount?.value,
    });
  }
  if (smartUpgradePrice > 0) {
    notes?.push({
      author: 'monthlySmartUpgradeDiscount',
      text: String(smartUpgradePrice),
    });
  }
  
  return notes;
};

export const alterHardwarePriceFormatDeviceDetail = (hardwarePrices: any[]): void => {
  const alteredPrices: any = {};

  (hardwarePrices || [])?.forEach((data: any) => {
    let priceContractTypeKey: string = data?.priceCategory;

    if (data?.duration === 0 && !data?.residual && data?.priceCategory === BASE) {
      priceContractTypeKey = BASE_PRICE;
    } else if (data?.duration === 24 && !data?.residual && data?.priceCategory === CONTRACT) {
      priceContractTypeKey = INSTALLMENTS;
    } else if (data?.duration === 24 && data?.residual && data?.priceCategory === CONTRACT) {
      priceContractTypeKey = SMARTUPGRADEINSTALLMENTS;
    }
    alteredPrices[priceContractTypeKey] = data;
  });

  return alteredPrices;
};
